import config from '~/common/config/config'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { cn } from '../@/lib/utils'

export const ENVIRONMENT_BANNER_HEIGHT = !config.isProduction ? 24 : 0

/**
 * Renders the environment banner at the top of the application.
 */
export const EnvironmentBanner = () => {
  const { t } = useTypedTranslation()
  const url = typeof window !== 'undefined' && window.location.href ? window.location.href : ''
  let env = t('environment.local')
  let color = 'bg-red-5 text-red-10'

  if (config.isProduction) {
    // Check for alpha-prod because it also uses NEXT_PUBLIC_VERCEL_ENV and NEXT_PUBLIC_ENV = production
    if (url.toLocaleLowerCase().includes('alpha-prod.')) {
      env = t('environment.alphaProd')
      color = 'bg-blue-5 text-blue-10'
    } else {
      return null
    }
  }

  if (config.isStaging) {
    env = t('environment.staging')
    color = 'bg-orange-5 text-orange-10'
  }
  // Check for alpha-prod first, then alpha
  if (url.toLocaleLowerCase().includes('alpha-prod.')) {
    env = t('environment.alphaProd')
    color = 'bg-blue-5 text-blue-10'
  } else if (url.toLocaleLowerCase().includes('alpha.')) {
    env = t('environment.alpha')
    color = 'bg-green-5 text-green-10'
  }

  return <div className={cn('h-6 flex items-center justify-center min-h-6', color)}>{env}</div>
}
